// Mantine v8 theme — PLAN.md §37 + Hard Rule #15 (WCAG 2.2 AA).
//
// Mantine `xs` ActionIcon = 18px which fails WCAG 2.2 AA criterion 2.5.8
// (Target Size Min: 24×24 CSS px). We override defaults globally:
//   - ActionIcon: size = 'sm' (26px)
//   - Button: size = 'sm'
//   - focusRing: 'always'
//
// Consumed by addin/, pwa/, dashboard/ — kept as a shared package so theme
// drift across surfaces can't happen.

import { type MantineThemeOverride, createTheme } from '@mantine/core';

/** WCAG 2.2 AA min CSS px target size — informational, not enforced at runtime. */
export const MIN_TOUCH_TARGET_PX = 24;

export const theme: MantineThemeOverride = createTheme({
  components: {
    ActionIcon: { defaultProps: { size: 'sm' } }, // 26px ≥ 24px min
    Button: { defaultProps: { size: 'sm' } },
  },
  focusRing: 'always',
  primaryShade: { light: 6, dark: 8 },
  // RTL-friendly defaults: rely on `dir="auto"` set by host containers and
  // CSS logical properties in custom styles.
});
